import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { t } from 'i18next';
import CopyButton from '../../../generic-components/CopyButton';
import { ReactComponent as CopyIcon } from '../../../assets/icons/svg/shared/ic-shared-duplicate.svg';
import Heading from '../../../generic-components/Heading';
import { LiliTooltip, LiliToolTipColor, TooltipPosition } from '../../../DesignSystem/LiliTooltip/LiliTooltip';

const COPY_BUTTON_TIMEOUT = 2000;

interface IProps {
  title: string;
  text: string;
  mixPanelKey: string;
  mixpanelTrack: string;
  id?: string;
}
export const TextWithCopyItem = ({ title, text, mixPanelKey, mixpanelTrack, id }: IProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const copyToClipboard = () => {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        mixpanel.track(mixpanelTrack, {
          Action: mixPanelKey,
        });
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
          setIsFocused(false);
        }, COPY_BUTTON_TIMEOUT);
      });
    }
  };
  //   const copy = t('DIRECT_DEPOSIT_PAGE_COPY');
  const copied = t('DIRECT_DEPOSIT_PAGE_COPIED');

  return (
    <div className='flex justify-between items-center h-[40px]'>
      <div className='flex flex-col gap-1'>
        <Heading type='HTML' title={title} className='text-bw07 text-[14px] font-metricR' />
        <span id={id || ''} className='font-metricR text-[16px] text-action03'>
          {text ?? ''}
        </span>
      </div>
      {isCopied ? (
        <span className='h-[40px] text-bw06 text-xs mt-auto font-metric self-center content-center'>{copied}</span>
      ) : (
        <>
          <CopyButton
            id={`${title}-copy-button`}
            data-tooltip-id={`${title}-copy-button`}
            className={`w-[2.625rem] h-[2.625rem] flex flex-col items-center text-xs font-metric relative bottom-[5px] rounded-md  text-action03 ${isFocused && 'bg-bw03'} `}
            title={isCopied ? '' : isFocused ? '' : ''}
            childElement={
              <CopyIcon
                id={`${title}-copy-icon`}
                className={`w-[36px] h-[36px] relative  top-[10px] ${isCopied ? 'text-action03' : 'text-bw06'} `}
              />
            }
            handleOnClick={() => {
              copyToClipboard();
            }}
            handleOnMouseIn={() => {
              setIsFocused(true);
            }}
            handleOnMouseOut={() => {
              setIsFocused(false);
            }}
          />
          <LiliTooltip
            description=''
            targetId={`${title}-copy-button`}
            position={TooltipPosition.BOTTOM}
            color={LiliToolTipColor.Black}
            customContent={<p>Copy</p>}
          />
        </>
      )}
    </div>
  );
};
